module.exports = __webpack_public_path__ + "media/images/illustrations/university-admissions-0db091a7c96d89e1cba6a6434b6c07f8.svg";